import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { get } from 'lodash';

import { addAllInstantShopItems } from 'apps/trolleyMenu/actions/trolleyMenu';
import InstantShop from '../components/InstantShop';

const connectedInstantShop = connect(
  state => ({
    isSuggestedOrderAvailable: get(state.user, 'shoppingDetails.suggestedOrderAvailable', false),
    numberOfItemsInBasket: state.basket.numberOfItems,
  }),
  dispatch => ({
    addAllInstantShopItems: () => dispatch(addAllInstantShopItems()),
  })
)(InstantShop);

export default withRouter(connectedInstantShop);
